class customDesignForm {
    constructor() {
        this.container = document.querySelector('[data-requestFormParent]');
        this.form = document.querySelector('[data-designRequestForm]');
        this.submitBtn = document.querySelector('[data-designRequestForm] button[type="submit"]');
        this.fileUpload = document.querySelector('[data-designRequestForm] input[name="reference-image"]');
        this.datepicker = document.querySelector('[data-designRequestForm] input.date-input');
        this.thankyouScreen = document.querySelector('[data-requestFormParent] .thank_you_screen');
        this.scrollToFormBtns = document.querySelectorAll('[data-openCustomForm], a[href="#openCustomRequestForm"]');
        this.imageFiles= [];
        this.imagesNames = [];
        this.uploads = [];
        this.uploadCounter = 0;
        this.uploadQueue = Promise.resolve();
        this.allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
        this.maxImageSize = 10 * 1024 * 1024; // upload-v2 limit (before base64)
        this.defaultFileLabel = this.form.querySelector('label.upload-file .file-name')?.textContent.trim() || 'Upload Image here';

        this._setupEventListeners();
    }
  

    _setupEventListeners() {
        this.form.addEventListener('submit', (evt)=>{
            evt.preventDefault();
            let validForm = this._validForSubmission();
            if(!validForm) return;

            this._submitForm(evt);
        });
        this.form.addEventListener('input', (_evt) =>{
            let invalidEle = this.form.querySelectorAll('.required-step.is-invalid');
            invalidEle.forEach(ele => ele.classList.remove('is-invalid'));
        });
        this.form.addEventListener('input', (_evt) =>{
            
            if (_evt.target.value.trim() == 'Gemstone' || _evt.target.value.trim() == 'gemstone' ) {
                this._showGemstoneOpt();
            }else{
                if (_evt.target.id == 'request-form-stone-type') {
                    this.form.querySelector('[data-key="gemstone-shape"]').classList.add('d-none');
                    this.form.querySelector('[data-key="gemstone-shape"]').classList.remove('required-step');    
                }
            }
        });
        this.scrollToFormBtns.forEach(btn => {
            btn.addEventListener('click', (evt)=> {
                evt.preventDefault();
                this.form.scrollIntoView({ behavior: "smooth", block: "nearest"});
            });
        });
        if(this.fileUpload) this.fileUpload.addEventListener('change', this._manageFileUpload.bind(this));
        if(this.datepicker){
            let lookForFlatpickr = setInterval(() => {
                if(typeof flatpickr == 'function'){
                    this.datepicker.flatpickr({
                        disableMobile: "true",
                        minDate: this.datepicker.min
                    });
                    clearInterval(lookForFlatpickr);
                } 
            }, 100);
        }
    }
    _showGemstoneOpt(){
        this.form.querySelector('[data-key="gemstone-shape"]').classList.remove('d-none');
        this.form.querySelector('[data-key="gemstone-shape"]').classList.add('required-step');
        
    }
    _validForSubmission(){
        const formData = new FormData(this.form);
        const requiredSteps = Array.from(this.form.querySelectorAll('.required-step'));
        
        this.requiredKeys = requiredSteps.map(step => step.dataset.key).filter(key => key !== null);

        let validInputs = true;
        this.requiredKeys.forEach((key) => {
            let value = (key == 'reference-image') ? this.imageFiles.join(',') : ((formData.get(key) != null && formData.get(key) != undefined) ? String(formData.get(key)).trim() : '');
            if(value.length == 0) {
                validInputs = false;
                let element = this.form.querySelector(`[name="${key}"]`);
                
                if(element) element.closest('.required-step').classList.add('is-invalid');
            }
        });

        if(!validInputs){            
            window.notificationEle.updateNotification('Input required!', 'Please fill in required details to submit the request.', {
                type: 'error',
                timeout: 10000
            });
            return false;
        }else if(!Utility.validateEmail(formData.get('email'))){
            window.notificationEle.updateNotification('Invalid email!', 'Please provide valid email', {
                type: 'error',
                timeout: 10000
            });
            return false;
        }

        return true;
    }

    async _submitForm(event){
        event.preventDefault();
        

        
        let formData = new FormData(this.form);
        let email = formData.get('email');
        let properties = {};

        if(!Utility.validateEmail(email)){
            window.notificationEle.updateNotification('Input required!', 'Please provide valid email to submit selection.', {
                type: 'error',
                timeout: 5000
            });
            return;
        }

        // Collect profile attributes
                let profileAttributes = {
                    email: formData.get('email'),
                    first_name: formData.get('first_name'),
                    last_name: formData.get('last_name')
                };

                // Extract and store country code (assuming it's from a select field or similar)
                let iti = (document.querySelector(".iti__selected-country")).title; // Example value: "India: +91"
                let countryCodeMatch = iti ? iti.match(/\+\d+/) : null;
                let countryCode = countryCodeMatch ? countryCodeMatch[0] : '';

                // Combine country code with phone number if available
                let phone = formData.get('phone_number');
                if (phone && phone.trim() !== '') {
                    let fullPhone = `${countryCode}${phone.trim()}`;
                    profileAttributes['phone_number'] = fullPhone;
                }

                // Collect custom design request event properties
                for (let [key, value] of formData.entries()) {
                    if (key == 'reference-image') continue;

                    let current = properties[key];
                    if (
                        key != 'first_name' &&
                        key != 'last_name' &&
                        key != 'email' &&
                        key != 'phone_number' &&
                        key != 'country_code' &&
                        value != null
                    ) {
                        if (current === undefined) {
                            properties[key] = value.trim();
                        } else {
                            properties[key] = `${properties[key]},${value.trim()}`;
                        }
                    }
                }

                // One URL per line: comma-joined Shopify CDN URLs (…?v=123,https://…) were auto-linked
                // as a single link in the seller email, so every link opened the first image.
                properties['reference-image'] = this.imageFiles.length
                    ? this.imageFiles.join('\n')
                    : 'Images are not attached by customer';
                properties['reference-image-count'] = this.imageFiles.length;
                // Same URLs as a list, so the seller email can loop and link each image separately.
                properties['reference_images'] = this.imageFiles;


        this.submitBtn.disabled = true;
        const eventData = {
            type: 'event',
            attributes: {
                properties: properties,
                metric: {data: {type: 'metric', attributes: {name: 'Design your own jewellery form submitted'}}},
                profile: {
                    data: {
                        type: 'profile',
                        attributes: profileAttributes
                    }
                }
            }
        };

        try {
            let fetchResponse = await this._registerKlaviyoEvt(eventData);
            if(fetchResponse.ok){
                // Show thank you modal (preferred) if it exists, otherwise fall back to inline thank-you screen.
                const thankYouModal = document.getElementById('ProductPopup-thankYou');
                if (thankYouModal && typeof openModal === 'function') {
                    openModal(thankYouModal, this.submitBtn);
                } else {
                this.container.classList.add('show-thankyou-screen');   
                // this._trackConversion();
                this.thankyouScreen.scrollIntoView({ behavior: "smooth", block: "nearest"}); 
                }
                this._addCustomerToList(formData.get('email'));
                this._resetForm();
            }else{
                let errRes = (typeof fetchResponse == 'object') ? fetchResponse : JSON.parse(fetchResponse);
                let title = (errRes.errors) ? errRes.errors[0].title : 'Invalid Input';
                let detail = (errRes.errors) ? errRes.errors[0].detail : 'Provide valid details';
                window.notificationEle.updateNotification(title, detail, {
                    type: 'error',
                    timeout: 10000
                });
                this.submitBtn.removeAttribute('disabled');
            }
        }catch(error){
            this.submitBtn.removeAttribute('disabled');
            window.notificationEle.updateNotification('Something went wrong!', JSON.stringify(error), {
                type: 'error',
                timeout: 10000
            });
            throw error;
        }
    }

    _resetForm() {
        try {
            // Clear validation states
            this.form?.querySelectorAll('.required-step.is-invalid')?.forEach(ele => ele.classList.remove('is-invalid'));

            // Reset native form fields
            this.form?.reset();

            // Reset internal file tracking + UI
            this.uploads.forEach(item => item.preview && URL.revokeObjectURL(item.preview));
            this.uploads = [];
            this.imageFiles = [];
            this.imagesNames = [];

            const fileName = this.form?.querySelector('label.upload-file .file-name');
            if (fileName) fileName.textContent = this.defaultFileLabel;

            const uploadList = this.form?.querySelector('[data-upload-list]');
            if (uploadList) uploadList.innerHTML = '';
            const uploadErrors = this.form?.querySelector('[data-upload-errors]');
            if (uploadErrors) uploadErrors.innerHTML = '';

            const fileInput = this.form?.querySelector('input[name="reference-image"]');
            if (fileInput) {
                fileInput.value = null;
                fileInput.removeAttribute('data-cdn');
            }

            const progressMsg = this.form?.querySelector('.image-upload-progress-msg');
            if (progressMsg) progressMsg.classList.add('d-none');

            const fileErr = this.form?.querySelector('.file-upload-error');
            if (fileErr) fileErr.classList.add('d-none');
        } catch (e) {
            console.error('Form reset error:', e);
        } finally {
            this.submitBtn?.removeAttribute('disabled');
        }
    }

    async _registerKlaviyoEvt(eventData){
        const apiResponse = await fetch("https://a.klaviyo.com/client/events/?company_id=YvqbLh", {
            method: "POST",
            headers: {'revision': '2024-05-15', 'content-type': 'application/json', 'accept': 'application/json'},
            body: JSON.stringify({
                data: eventData
            })
        })

        if(!apiResponse.ok) {
            return apiResponse.text();
        }else {
           return (typeof apiResponse == 'object') ? apiResponse : apiResponse.json();
        } 
    }

    async _manageFileUpload(event){
        const input = event.currentTarget;
        const fileErr = this.form.querySelector('.file-upload-error');
        const files = Array.from(input.files || []);

        if(fileErr) fileErr.classList.add('d-none');
        // Clear the native input so the same file can be picked again; selected files are tracked in this.uploads.
        input.value = '';
        if(!files.length) return;

        // Show every file right away, but upload them one after another (the API asks for no parallel calls).
        // Later selections join the same queue.
        files.forEach(file => {
            const upload = { id: ++this.uploadCounter, name: file.name, url: null, status: 'uploading', message: '', preview: URL.createObjectURL(file) };
            this.uploads.push(upload);
            this.uploadQueue = this.uploadQueue.then(() => this._uploadImage(file, upload, input));
        });
        this._renderUploads(input);
        await this.uploadQueue;
    }

    async _uploadImage(file, upload, input){
        // Skip files removed (or cleared by a form reset) while waiting in the queue.
        if(!this.uploads.includes(upload)) return;

        const fail = (message) => {
            upload.status = 'error';
            upload.message = message;
            this._renderUploads(input);
        };

        if(!this.allowedImageTypes.includes(file.type)){
            fail('Only JPEG, PNG or GIF images are allowed');
            return;
        }
        if(file.size > this.maxImageSize){
            fail(`Too large (${(file.size / (1024**2)).toFixed(1)}MB). Max 10MB`);
            return;
        }

        const base64 = await Utility.convertImageToBase64(file);
        if(base64 == null){
            fail('Could not read this file');
            return;
        }

        const imageDimentions = await Utility.checkFormDimentions(base64);
        if(imageDimentions.width > 5000 || imageDimentions.height > 5000){
            fail(`Too large (${imageDimentions.width}*${imageDimentions.height}px). Max 5000*5000px`);
            return;
        }

        // A 500 can succeed on a second try; every other error will fail again, so retry only that once.
        let result = await this._postImage(base64);
        if(!result.ok && result.status === 500) result = await this._postImage(base64);

        if(!result.ok){
            fail(result.error);
            return;
        }
        upload.url = result.url;
        upload.status = 'done';
        this._renderUploads(input);
    }

    // Sends one base64 image to upload-v2 and returns { ok, url } or { ok, status, error }.
    async _postImage(base64){
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 60000); // Shopify can take ~45s

        try {
            const response = await fetch('https://certificate-manager.diamondrensu.com/api/image/upload-v2', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Shop': 'diamondrensu-new.myshopify.com'
                },
                body: JSON.stringify({image: base64}),
                signal: controller.signal
            });

            // 413 comes back as an HTML page, so don't parse it.
            if(response.status === 413) return { ok: false, status: 413, error: 'Image is too large' };

            const data = await response.json().catch(() => ({}));
            if(response.ok && data.image_url) return { ok: true, url: data.image_url };

            // 422 validation errors are keyed by field; store/server errors are a plain string; 429 uses "message".
            const error = (data.errors && typeof data.errors === 'object')
                ? (data.errors.image?.[0] || Object.values(data.errors).flat()[0])
                : (data.errors || data.message);
            return { ok: false, status: response.status, error: error || 'Upload failed' };
        } catch(error) {
            console.error('Image upload error:', error);
            return { ok: false, status: 0, error: 'Upload timed out or network error' };
        } finally {
            clearTimeout(timer);
        }
    }

    _removeUpload(id, input){
        const upload = this.uploads.find(item => item.id === id);
        if(upload?.preview) URL.revokeObjectURL(upload.preview);
        this.uploads = this.uploads.filter(item => item.id !== id);
        this._renderUploads(input);
    }

    _getUploadList(input){
        let list = this.form.querySelector('[data-upload-list]');
        if(!list){
            list = document.createElement('ul');
            list.setAttribute('data-upload-list', '');
            list.className = 'upload-file-list list-unstyled d-flex flex-nowrap gap-2 mb-0 mt-2';
            input.closest('.form-check').after(list);
        }
        return list;
    }

    // Syncs the uploaded image list, the label summary, data-cdn and the submit button with this.uploads.
    _renderUploads(input){
        const fileName = this.form.querySelector('label.upload-file .file-name');
        const progressMsg = this.form.querySelector('.image-upload-progress-msg');
        const list = this._getUploadList(input);
        const done = this.uploads.filter(item => item.status === 'done');
        const uploading = this.uploads.some(item => item.status === 'uploading');

        this.imageFiles = done.map(item => item.url);
        this.imagesNames = done.map(item => item.name);
        if(this.imageFiles.length) input.dataset.cdn = this.imageFiles.join(',');
        else input.removeAttribute('data-cdn');

        if(fileName){
            fileName.textContent = done.length
                ? `${done.length} image${done.length > 1 ? 's' : ''} attached. Click to add more`
                : this.defaultFileLabel;
        }
        if(progressMsg) progressMsg.classList.toggle('d-none', !uploading);
        if(uploading) this.submitBtn.disabled = true;
        else this.submitBtn.removeAttribute('disabled');

        // One horizontal row of thumbnails (no names); it scrolls sideways when there are many.
        list.innerHTML = '';
        this.uploads.forEach((item, index) => {
            const li = document.createElement('li');
            li.className = `upload-file-item flex-shrink-0 is-${item.status}`;
            li.title = item.status === 'error' ? `${item.name}: ${item.message}` : item.name;

            const thumb = document.createElement('img');
            thumb.className = 'upload-file-thumb';
            thumb.src = item.preview;
            thumb.alt = `Image ${index + 1}`;
            thumb.width = 64;
            thumb.height = 64;
            li.append(thumb);

            if(item.status === 'uploading'){
                const spinner = document.createElement('span');
                spinner.className = 'upload-file-spinner spinner-border spinner-border-sm text-primary';
                spinner.setAttribute('role', 'status');
                li.append(spinner);
            }

            const remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'upload-file-remove btn p-0';
            remove.setAttribute('aria-label', `Remove image ${index + 1}`);
            remove.innerHTML = '&times;';
            remove.disabled = item.status === 'uploading';
            remove.addEventListener('click', () => this._removeUpload(item.id, input));
            li.append(remove);

            list.append(li);
        });

        // Rejected files are only marked red in the row, so spell out why below it.
        let errors = list.nextElementSibling?.matches('[data-upload-errors]') ? list.nextElementSibling : null;
        if(!errors){
            errors = document.createElement('div');
            errors.setAttribute('data-upload-errors', '');
            errors.className = 'upload-file-errors fs-xs text-danger';
            list.after(errors);
        }
        errors.innerHTML = '';
        this.uploads.forEach((item, index) => {
            if(item.status !== 'error') return;
            const line = document.createElement('span');
            line.className = 'd-block pt-1';
            line.textContent = `Image ${index + 1}: ${item.message}`;
            errors.append(line);
        });
    }

    async _addCustomerToList(customerEmail){
        const senderData = {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: customerEmail
                  }
                }
              }
            },
            relationships: {list: {data: {type: 'list', id: 'V6DLCi'}}}
        }
        
        const apiResponse = await fetch("https://a.klaviyo.com/client/subscriptions/?company_id=YvqbLh", {
            method: "POST",
            headers: {'revision': '2024-05-15', 'content-type': 'application/json'},
            body: JSON.stringify({
                data: senderData
            })
        });

        return apiResponse;
    }
}
typeof customDesignForm !== 'undefined' && new customDesignForm();
